export default __webpack_public_path__ + "static/media/lavaTut.2f0eee4b.png";